import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface EstadoSuperficiePayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface EstadoSuperficie {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface EstadoSuperficieResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class EstadoSuperficieService {
  private readonly apiUrl = `${environment.apiUrl}/api/estado_superficie`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<EstadoSuperficie[]> {
    return this.http.get<EstadoSuperficie[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<EstadoSuperficie> {
    return this.http.get<EstadoSuperficie>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear
  create(
    payload: EstadoSuperficiePayload
  ): Observable<EstadoSuperficieResponse> {
    return this.http.post<EstadoSuperficieResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<EstadoSuperficiePayload>
  ): Observable<EstadoSuperficieResponse> {
    return this.http.put<EstadoSuperficieResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar
  inactivar(id: number): Observable<EstadoSuperficieResponse> {
    return this.http.put<EstadoSuperficieResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar
  activar(id: number): Observable<EstadoSuperficieResponse> {
    return this.http.put<EstadoSuperficieResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}